import { GetterTree } from 'vuex';
import { State } from './state';

import { RootState } from '@/modules/ewerp/store';
import { MitarbeiterArbeitszeit } from '@/modules/ewerp/models/PersonaldatenModels';

export type Getters = {
  mitarbeiterArbeitszeiten(state: State): Array<MitarbeiterArbeitszeit>;
};

export const getters: GetterTree<State, RootState> & Getters = {
  mitarbeiterArbeitszeiten(state: State): Array<MitarbeiterArbeitszeit> {
    return state.mitarbeiterArbeitszeiten;
  },
};
